// 所有网络接口返回的code枚举
export enum ResponseCodeEnum {
  SUCCESS = 0, // 成功
  SYSTEM_BUSY = 10000001, // 系统繁忙
  HELLO_RULE_NOT_PASS = 10000002, // 审核未通过
  USER_INFO_LACK = 10000003, // 请完善资料
  WRONG_USER = 10000004, // 错误的用户
  NO_BANK_CARD = 10000009, // 未绑定储蓄卡
  PRODUCT_RULE_NOT_PASS = 10000010, // 初审未通过
  PRODUCT_RULE_PARAMS_ERROR = 10000011, // 初审异常
  WRONG_AMOUNT = 10000015, // 金额错误
  CREDIT_ERROR = 10000021, // 没有授信成功记录或者授信已过期或剩余额度为0
  PARAM_NO_EXITS = 10000222, // 参数校验未通过
  WRONG_COMMODITY = 10000005, // 错误的渠道
  CANNOT_ORDER_AGAIN = 10000006, // 您的订单正在进行中
  WRONG_ORDER = 10000007, // 错误的订单
  REPAYMENT_ERROR = 10000009, // 还款失败
  REMIT_ERROR = 10000010, // 确认放款失败，错误的用户
  REMIT_ERROR_1 = 10000110, // 确认放款失败
  REMIT_FAILD = 10000012, // 放款失败
  REPAYMENT_FAILD = 10000013, // 还款失败，错误的银行卡
  WRONG_REPATMENT_TYPE = 10000014, // 错误的还款状态
  REPAYMENT_OVERDUE_FIRST = 10000016, // 请先偿还逾期
  REPAYMENT_IN_FIVE_DAY = 10000017, // 最多提前五天还款
  REPAYMENT_IN_ZERO_DAY = 10000117, // 仅限还款日当天及以后还款
  IN_REMIT = 10000018, // 正在放款中
  CHARGE_FEE = 10000019, // 免息期内不能提前结清
  UNFINISHED_REPAYMENT_ORDER = 10000020, // 您还有一笔还款订单正在支付中，请耐心等待
  PASSWORD_TOKEN_IS_NULL = 10000022, // 资金密码为空 || 您的交易密码已失效，请重新输入
  PASSWORD_TOKEN_IS_ERROR = 10000023, // 您的交易密码已失效，请重新输入
  NO_REQUESR_ORDER = 10000024, // 无放款订单
  ZREO_AMOUNT = 10000025, // 当前无需还款
  BANK_CARD_CHECK_NULL = 10000026, // 银行卡未绑定
  ALIPAY_ACCOUNT_CHECK_NULL = 10000027, // 支付宝账号未绑定
  ALIPAY_SIGN_CHECK_NULL = 10000028, // 支付宝代扣未签署
  ALIPAY_ERROR = 10000029, // 支付宝还款失败
  FIRST_MONTH_CAN_NOT = 10000030, // 首月内不能提前结清
  THREE_MONTH_CAN_NOT = 10000037, // 前三月内不能提前结清
  EVERY_DAY_CAN_NOT = 10000031, // 还款日不能提前结清
  LENT_DAY_CAN_NOT = 10000034, // 借款当日不能提前结清
  CAN_NOT_EARLY_IN_THREE = 10000035, // 三期内不能提前结清
  NEED_FACECHECK = 10000036, // 需要人脸识别
  SMS_IS_NULL = 10000032, // 短信码为空
  PAYORDER_IS_NULL = 10000033, // 还款订单为空
  ORDER_CHECK_ERROR = 10000038, // 下单检测异常
  ORDER_CHECK_NOT = 10000047, // 检测不通过
  LOAN_ORDER_CHECK_NOT = 10000048, // 渠道准入检测异常
  LOAN_ORDER_CHECK_REJECT = 10000049, // 渠道准入检测不准入
  REPAYMENT_PLAN_IS_NULL = 10000050, // 还款计划为空
  PERIOD_IS_NULL = 10000051, // 期数为空
  ALLREADY_PAYOFF = 10000052, // 当期已还清，无需重复还款
  ALL_PAYOFF = 10000053, // 已全部还清，无需重复还款
  PERIOD_NOT_SUPPORT = 10000054, // 当前期数不支持还款
  WRONG_STATE_ENUM = 10000008, // 错误的状态
  COUPON_ERROR = 10000037, // 优惠券锁定失败
  NEED_SUPPLY_BEFORE_CALC_REPAYPLAN = 720001, // 提现模块还款试算部分渠道要求先补充资料
  CHANGE_BANK_CARD = -10, // 提现或者还款需要重新绑卡或者换卡
  CHECK_DIALOG_CONFIRM = -99, // 无资金路由
  RIGHT_PARAMS_ERROR = 10000063, // 权益入参错误
  LOAN_ORDER_CHECK_FUND_ROUTE_ID = 600001, // 资金路由ID重复
  AUTARKY_QUOTE_LIMIT = 600060, // 自营B命中限额限制
  /** 支付宝场景提现试算36引导弹窗 */
  ALIPAY_36_GUIDE = 600021,
}
